import "./styles.scss";
import React, { FC, useMemo, useEffect } from "react";
import SocialIcon from "SocialIcon/SocialIcon";
// import { useSelector } from "react-redux";
// import { PsState } from "../../TrixtaComponents/store/paperstreetReducer";

// interface ISocials {
//   title: string;
//   icon: string;
// }

// interface ISocialLinks extends ISocials {
//   link: string | unknown;
// }

// interface IState {
//   trixta: {};
//   paperstreet: PsState;
//   phoenix: {};
// }

// const socialAssets: ISocials[] = [
//   { title: "linkedin", icon: "/images/icons/linkedin-greyscale.svg" },
//   { title: "twitter", icon: "/images/icons/social/Twitter-grey.svg" },
//   { title: "telegram", icon: "/images/icons/telegram-grey.svg" },
//   { title: "github", icon: "/images/icons/github-grey.svg" },
//   { title: "facebook", icon: "/images/icons/facebook-grey.svg" },
//   { title: "crunchbase", icon: "/images/icons/crunchbase-colorized.svg" },
//   { title: "instagram", icon: "/images/icons/instagram-colorized.svg" },
//   { title: "medium", icon: "/images/icons/medium-grey.svg" },
//   { title: "reddit", icon: "/images/icons/reddit-colorized.svg" },
//   { title: "youtube", icon: "/images/icons/youtube-colorized.svg" },
// ];
interface IProps {
  company: {
    company_id: string;
    name: string;
    linkedin_url: string;
    twitter_url: string;
    instagram_url: string;
    youtube_url: string;
    telegram_url: string;
    github_url: string;
    facebook_url: string;
    medium_url: string;
    reddit_url: string;
    discord_url: string;
    angellist_url: string;
    crunchbase_url: string;
  };
}

const CompanySocialCard: FC<IProps> = (props) => {
  // const { paperstreet } = useSelector((state: IState) => state);
  const { company } = props;

  let displaySocialsCard = false;

  if (company.linkedin_url && company.linkedin_url.length) {
    displaySocialsCard = true;
  }

  if (company.twitter_url && company.twitter_url.length) {
    displaySocialsCard = true;
  }

  if (company.instagram_url && company.instagram_url.length) {
    displaySocialsCard = true;
  }

  if (company.telegram_url && company.telegram_url.length) {
    displaySocialsCard = true;
  }

  if (company.github_url && company.github_url.length) {
    displaySocialsCard = true;
  }

  if (company.facebook_url && company.facebook_url.length) {
    displaySocialsCard = true;
  }

  if (company.medium_url && company.medium_url.length) {
    displaySocialsCard = true;
  }

  if (company.reddit_url && company.reddit_url.length) {
    displaySocialsCard = true;
  }

  if (company.discord_url && company.discord_url.length) {
    displaySocialsCard = true;
  }

  if (company.youtube_url && company.youtube_url.length) {
    displaySocialsCard = true;
  }

  if (company.angellist_url && company.angellist_url.length) {
    displaySocialsCard = true;
  }

  if (company.crunchbase_url && company.crunchbase_url.length) {
    displaySocialsCard = true;
  }

  // useEffect(() => {
  //   first;

  //   return () => {
  //     second;
  //   };
  // }, [third]);

  return (
    <>
      {displaySocialsCard === true && (
        <div
          className="ps-company-detail-content__socials-card"
          style={{ height: "fit-content" }}
        >
          <div className="project-detail-social-icons">
            {company.linkedin_url && company.linkedin_url.length && (
              <SocialIcon
                iconType="linkedin"
                href={company.linkedin_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}

            {company.twitter_url && company.twitter_url.length && (
              <SocialIcon
                iconType="twitter"
                href={company.twitter_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.instagram_url && company.instagram_url.length && (
              <SocialIcon
                iconType="instagram"
                href={company.instagram_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.telegram_url && company.telegram_url.length && (
              <SocialIcon
                iconType="telegram"
                href={company.telegram_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}

            {company.github_url && company.github_url.length && (
              <SocialIcon
                iconType="github"
                href={company.github_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.facebook_url && company.facebook_url.length && (
              <SocialIcon
                iconType="facebook"
                href={company.facebook_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}

            {company.medium_url && company.medium_url.length && (
              <SocialIcon
                iconType="medium"
                href={company.medium_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.reddit_url && company.reddit_url.length && (
              <SocialIcon
                iconType="reddit"
                href={company.reddit_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}

            {company.discord_url && company.discord_url.length && (
              <SocialIcon
                iconType="discord"
                href={company.discord_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.youtube_url && company.youtube_url.length && (
              <SocialIcon
                iconType="youtube"
                href={company.youtube_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.angellist_url && company.angellist_url && (
              <SocialIcon
                iconType="angellist"
                href={company.angellist_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
            {company.crunchbase_url && company.crunchbase_url.length && (
              <SocialIcon
                iconType="crunchbase"
                href={company.crunchbase_url}
                companyName={company.name}
                companyId={company.company_id}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CompanySocialCard;
